import { REGISTRATION_STORAGE_KEYS, DEFAULT_SKIP_ONBOARDING_DATA } from './registrationConstants.ts';

export const getRegistrationEmail = (): string | null => {
  return localStorage.getItem(REGISTRATION_STORAGE_KEYS.EMAIL);
};

export const setRegistrationEmail = (email: string): void => {
  localStorage.setItem(REGISTRATION_STORAGE_KEYS.EMAIL, email);
};

export const clearRegistrationEmail = (): void => {
  localStorage.removeItem(REGISTRATION_STORAGE_KEYS.EMAIL);
};

export const getFromLoginValidation = (): boolean => {
  return localStorage.getItem(REGISTRATION_STORAGE_KEYS.FROM_LOGIN_VALIDATION) === 'true';
};

export const setFromLoginValidation = (value: boolean): void => {
  if (value) {
    localStorage.setItem(REGISTRATION_STORAGE_KEYS.FROM_LOGIN_VALIDATION, 'true');
  } else {
    localStorage.removeItem(REGISTRATION_STORAGE_KEYS.FROM_LOGIN_VALIDATION);
  }
};

export const clearFromLoginValidation = (): void => {
  localStorage.removeItem(REGISTRATION_STORAGE_KEYS.FROM_LOGIN_VALIDATION);
};

export const setSkipOnboardingData = (data: typeof DEFAULT_SKIP_ONBOARDING_DATA): void => {
  Object.entries(data).forEach(([key, value]) => {
    localStorage.setItem(`${key}New`, JSON.stringify(value));
  });
};

export const clearOnboardingData = (): void => {
  Object.keys(REGISTRATION_STORAGE_KEYS).forEach((key) => {
    const storageKey = REGISTRATION_STORAGE_KEYS[key as keyof typeof REGISTRATION_STORAGE_KEYS];
    if (storageKey.includes('New')) {
      localStorage.removeItem(storageKey);
    }
  });
};
